module.exports = __webpack_public_path__ + "static/3-c3c247ded4c81736ff3389328f4195e5.png";